import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalyticsFilters } from '@brand-lolly/app/social-media-influencer/modules/social-listening/models/social-listening-analytics.model';
import { advancedPostToQuery } from '@brand-lolly/app/social-media-influencer/modules/social-listening/components/advanced-filters/advanced-filters.types';
import { SlMatchTypeFilter } from '@brand-lolly/app/social-media-influencer/modules/social-listening/components/filters/match-type/match-type.component';
import { recoverUnlessStrict } from '@brand-lolly/app/social-media-influencer/modules/social-listening/services/recover-unless-strict';
import { smiUrl } from 'components';
import { map, Observable } from 'rxjs';

export interface MediaTypeInfluencer {
	platform: string;
	count: number;
}

interface MediaTypeInfluencerApi {
	platform: string;
	count: number;
}

interface InfluencersByMediaTypeResponseApi {
	social_medias: MediaTypeInfluencerApi[];
}

@Injectable({
	providedIn: 'root'
})
export class GetSocialListeningMyBrandAnalyticsInfluencersByMediaTypeService {
	constructor(private http: HttpClient) {}

	private applyFilters(
		b: any,
		filters?: AnalyticsFilters,
		matchType?: SlMatchTypeFilter
	): void {
		if (filters?.platforms?.length)
			b.query('platforms', filters.platforms.join(','));
		if (filters?.sentiments?.length)
			b.query('sentiments', filters.sentiments.join(','));
		if (filters?.emotions?.length)
			b.query('emotions', filters.emotions.join(','));
		if (filters?.languages?.length)
			b.query('languages', filters.languages.join(','));
		if (filters?.engagementRate) {
			b.query('engagement_rate_min', String(filters.engagementRate[0]));
			b.query('engagement_rate_max', String(filters.engagementRate[1]));
		}
		if (matchType) b.query('match_type', matchType);
		for (const [advKey, advVal] of Object.entries(
			advancedPostToQuery(filters?.advanced)
		)) {
			b.query(advKey, advVal);
		}
	}

	fetch(
		brandId: string,
		cutoff?: Date | null,
		filters?: AnalyticsFilters,
		to?: Date | null,
		matchType?: SlMatchTypeFilter,
		strict = false
	): Observable<MediaTypeInfluencer[]> {
		const urlBuilder = smiUrl()
			.add('social-listening')
			.add('brand')
			.add(brandId)
			.add('analytics-influencers-by-media-type');

		if (cutoff) {
			urlBuilder.query('from', cutoff.toISOString());
		}
		if (to) {
			urlBuilder.query('to', to.toISOString());
		}
		this.applyFilters(urlBuilder, filters, matchType);

		const url = urlBuilder.done();

		return this.http.get<InfluencersByMediaTypeResponseApi>(url).pipe(
			recoverUnlessStrict(
				strict,
				(): InfluencersByMediaTypeResponseApi => ({
					social_medias: []
				})
			),
			map(r => r.social_medias)
		);
	}
}
